import Link, { LinkProps } from 'next/link';

export default function SafeLink(
  props: LinkProps & {
    children?: React.ReactNode;
    className?: string;
    target?: string; // 新增 target 属性
  },
) {
  const safeProps = Object.assign({}, props, {
    href: props?.href || '#',
    target: props.target || undefined,
  });

  return <Link {...safeProps}>{props.children}</Link>;
}
